// extracted by mini-css-extract-plugin
export default {"zoomModal":"M2-z","image":"N2-z","button":"O2-z","isOverlayShown":"P2-z"};